var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editBox"
  }, [_c("div", {
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("delItem");
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "delete"
    }
  })], 1), _vm.upShow ? _c("div", {
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("upItem");
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "up-circle"
    }
  })], 1) : _vm._e(), _vm.downShow ? _c("div", [_c("a-icon", {
    attrs: {
      type: "down-circle"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("downItem");
      }
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };